import {
  OnboardingPartnerServiceMethods,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import { Nullable } from 'cng-common/models/utils'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { TResponse } from 'core/classes/ws/WebSocketClient'

import { ContactStatus } from '../model/types'

import { normalizedSearchPortalData } from './mapping'

export type TSearchPortalContact = {
  contactId: string
  communicationName: string
  countryOfBusiness: string // ISO
  emailAddress: string
  firstName: string
  hpRoles: string[]
  lastName: string
  locationId: string
  partnerId: string
  requestor: {
    emailAddress: string
    id: number
  }
  salutation: string
  status: ContactStatus
  userType: string
}

export type TSearchPortalContactResponse = { contact: Nullable<TSearchPortalContact> }

type TErrorResponse = Array<{ message: string }>

export async function searchPortalContact(
  email: string
): Promise<TResponse<TSearchPortalContactResponse & { error?: TErrorResponse }>> {
  const token = getAccessToken()
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  return wsClient
    .call<TSearchPortalContactResponse & { error: TErrorResponse }>({
      service: OnboardingServices.Contact,
      action: OnboardingPartnerServiceMethods.SearchPortalContact,
      payload: { email },
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
      returnError: true,
    })
    .then((response) => {
      if (response?.data?.contact) {
        return {
          ...response,
          data: {
            ...response.data,
            contact: normalizedSearchPortalData(response.data.contact),
          },
        }
      }

      return response
    })
}
